module.exports = __webpack_public_path__ + "static/media/banner_sevenUpDown-half.46013ac2.png";